import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-icon',
  templateUrl: './eye-icon.component.html',
  styleUrl: './eye-icon.component.scss'
})
export class EyeIconComponent {

}
